export default "__VITE_ASSET__BNma$QD2__"